import { SelectChangeEvent } from '@mui/material';
import { NativeSelect, NativeSelectProps } from '@village/ui';
import { useCallback, useEffect, useMemo } from 'react';
import { Path, useController } from 'react-hook-form';

type Props<FormSchema> = NativeSelectProps & {
    name: Path<FormSchema>;
};

const DropdownForm = <FormSchema,>({ name, ...props }: Props<FormSchema>) => {
    const { field, fieldState } = useController({ name, disabled: props.isDisabled });

    const { value, onBlur, onChange } = field;

    const selectedOption = useMemo(() => props.options.find((option) => option.value === value) ?? null, [props.options, value]);

    const handleOnChange = useCallback(
        (event: SelectChangeEvent<unknown> | null) => {
            onChange(event?.target.value ?? undefined);
        },
        [onChange]
    );

    useEffect(() => {
        if (selectedOption === null && value !== undefined) {
            handleOnChange(null);
        }
    }, [handleOnChange, selectedOption, value]);

    return (
        <NativeSelect
            {...props}
            error={fieldState.error?.message}
            onBlur={onBlur}
            onChange={handleOnChange}
            value={selectedOption?.value}
            placeholder="Please select"
        />
    );
};

export { DropdownForm };
